import {RecruitingGroupResponseItem, RecruitingGroupResponseList} from '@/types/service-response'

export class RecruitingGroup {
  public constructor (
    readonly id: number,
    readonly name: string,
    readonly text: string,
    readonly code: string,
    readonly children: any[]
  ) {}

  static createFromResponse (responseData: RecruitingGroupResponseList): Array<RecruitingGroup> {
    let result: Array<RecruitingGroup> = []
    if (responseData) {
      result = responseData.map((item: RecruitingGroupResponseItem ) => {
        return new RecruitingGroup(
          item.ID,
          item.Bezeichnung,
          `${item.Bezeichnung} (${item.Code})`,
          item.Code,
          item.children
        )
      })
    }
    return result
  }
}
